<button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori procjenu nadređenog">
    <mat-icon>close</mat-icon>
</button>

<mat-dialog-content class="!max-h-[78vh] !p-0">
    <div class="px-6 pb-6 sm:px-8 sm:pb-8">
        <header class="mb-6 border-b border-gray-200 pb-5 pr-10">
            <h2 class="text-2xl font-bold text-gray-800">Procjena nadređenog</h2>
            @if (data) {
                <p class="mt-1 text-sm text-gray-500">
                    Procjenu ispunio/la
                    <span class="font-semibold text-gray-700">{{ data.evaluatedByUser }}</span>
                </p>
            }
        </header>

        @if (!data) {
            <div class="flex min-h-40 flex-col items-center justify-center gap-3 text-center text-gray-500">
                <mat-icon class="!h-10 !w-10 text-[2.5rem] !leading-10 text-gray-300">assignment_late</mat-icon>
                <p>Prijava još nije ocijenjena.</p>
            </div>
        }

        @if (data) {
            <div class="space-y-4">
                <div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3.5">
                    <p class="font-semibold leading-6 text-gray-700">
                        Je li navedeni djelatnik ključan za rad vašeg tima?
                    </p>
                    <span
                        class="inline-flex min-w-16 items-center justify-end gap-1.5 text-sm font-semibold"
                        role="img"
                        [attr.aria-label]="data.keyForWork ? 'Da' : 'Ne'"
                        [attr.title]="data.keyForWork ? 'Da' : 'Ne'"
                        [class.text-green-700]="data.keyForWork"
                        [class.text-gray-500]="!data.keyForWork">
                        <mat-icon class="!h-6 !w-6 text-2xl !leading-6">
                            {{ data.keyForWork ? "check_circle" : "highlight_off" }}
                        </mat-icon>
                        {{ data.keyForWork ? "Da" : "Ne" }}
                    </span>
                </div>

                @if (data.keyForWork && data.keyForWorkComment.length) {
                    <section class="rounded-xl border border-blue-100 bg-blue-50/60 px-4 py-3.5">
                        <h3 class="mb-2 text-sm font-semibold text-gray-700">Djelatnik je ključan zbog:</h3>
                        <ul class="space-y-1.5 text-sm leading-5 text-gray-600">
                            @for (item of data.keyForWorkComment; track $index) {
                                <li class="flex items-start gap-2">
                                    <mat-icon class="mt-1 !h-3 !w-3 text-xs !leading-3 text-valamarblueprimary">
                                        fiber_manual_record
                                    </mat-icon>
                                    <span>{{ item }}</span>
                                </li>
                            }
                        </ul>
                    </section>
                }

                <div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3.5">
                    <p class="font-semibold leading-6 text-gray-700">
                        Doprinos djelatnika timu na ljestvici od 1 do 5
                    </p>
                    <span class="inline-flex h-9 min-w-14 items-center justify-center rounded-lg bg-valamarblueprimary px-3 text-base font-bold text-white">
                        {{ data.teamContribution }}/5
                    </span>
                </div>

                <section>
                    <h3 class="mb-2 font-semibold leading-6 text-gray-700">
                        Specifična znanja, vještine i kompetencije djelatnika
                    </h3>
                    <p class="min-h-12 rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm leading-6 text-gray-700">
                        {{ data.competencyComment || "—" }}
                    </p>
                </section>

                <div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3.5">
                    <p class="font-semibold leading-6 text-gray-700">
                        Postoji li rizik da djelatnik napusti kompaniju?
                    </p>
                    <span
                        class="inline-flex min-w-16 items-center justify-end gap-1.5 text-sm font-semibold"
                        role="img"
                        [attr.aria-label]="data.riskOfLeavingCompany ? 'Da' : 'Ne'"
                        [attr.title]="data.riskOfLeavingCompany ? 'Da' : 'Ne'"
                        [class.text-green-700]="data.riskOfLeavingCompany"
                        [class.text-gray-500]="!data.riskOfLeavingCompany">
                        <mat-icon class="!h-6 !w-6 text-2xl !leading-6">
                            {{ data.riskOfLeavingCompany ? "check_circle" : "highlight_off" }}
                        </mat-icon>
                        {{ data.riskOfLeavingCompany ? "Da" : "Ne" }}
                    </span>
                </div>

                <div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3.5">
                    <p class="font-semibold leading-6 text-gray-700">
                        Je li djelatnik potencijal za dugoročno zadržavanje i razvoj u kompaniji?
                    </p>
                    <span
                        class="inline-flex min-w-16 items-center justify-end gap-1.5 text-sm font-semibold"
                        role="img"
                        [attr.aria-label]="data.longTermPotential ? 'Da' : 'Ne'"
                        [attr.title]="data.longTermPotential ? 'Da' : 'Ne'"
                        [class.text-green-700]="data.longTermPotential"
                        [class.text-gray-500]="!data.longTermPotential">
                        <mat-icon class="!h-6 !w-6 text-2xl !leading-6">
                            {{ data.longTermPotential ? "check_circle" : "highlight_off" }}
                        </mat-icon>
                        {{ data.longTermPotential ? "Da" : "Ne" }}
                    </span>
                </div>

                <section>
                    <h3 class="mb-2 font-semibold leading-6 text-gray-700">
                        Mišljenje o ostvarivanju prava na subvenciju
                    </h3>
                    <p class="min-h-12 rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm leading-6 text-gray-700">
                        {{ data.eligibleForSubsidyComment || "—" }}
                    </p>
                </section>
            </div>
        }
    </div>
</mat-dialog-content>
